import { actions } from "../../actions/media/media";

export default function media( state = {}, action ) {

    const newState = { ...state };

    switch( action.type ) {
        // Probably not being used anymore as they are for the old blogs 
        case actions.GET_MEDIA: return getMedia( newState, action.media );
        case actions.GET_SINGLE_MEDIA: return getSingleMedia( newState, action.singleMedia);
        case actions.OPEN_PLAYER: return openPlayer(newState, action)
        case actions.CLOSE_PLAYER: return closePlayer(newState, action)

        default: return state;
    }
}

function getMedia( newState, media ) {

    newState.media = media;

    // newState.pagination = action.pagination;
    // newState.options = action.options;

    return newState;
}


function getSingleMedia( newState, singleMedia ) {

  newState.singleMedia = singleMedia;
  return newState;
}

function openPlayer( newState, action ) {
    newState.showMp3 = action.showMp3;
    newState.mp3Tracks = action.mp3Tracks;
    newState.currentIndex = action.currentIndex;
  return newState;
}

function closePlayer( newState, action ) {
  newState.showMp3 = action.showMp3;
return newState;
}


// WEBPACK FOOTER //
// src/client/reducers/media/media.js